export default (theme) => ({
  pageContent: {
    marginLeft: 220,
  },
  inputContainerStyle: {
    padding: "20px 30px 30px 30px",
  },
  headerStyle: {
    padding: "20px 30px",
    border: "1px solid #c5c5c7",
  },
  indicatorContainer: {
    paddingRight: "40px !important",
  },
  textStyle: {
    fontSize: 13,
    fontWeight: 600,
  },
  textStyle2: {
    fontSize: 13,
    fontWeight: 400,
    color: "#898B8E",
  },
});
